const uuidv4 = require('uuid/v4');
var AWS = require('aws-sdk');
// var AWS_KEY_ID = 'AKIAIIPREWY2WG5YUGPA';
// var AWS_SECRET_KEY = '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';
var AWS_KEY_ID = 'AKIAI5T3G44CIZG6OXJA';
var AWS_SECRET_KEY = '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';
const md5 = require('js-md5');

AWS.config.update({
  region: "us-east-1",
  // accessKeyId default can be used while using the downloadable version of DynamoDB. 
  // For security reasons, do not store AWS Credentials in your files. Use Amazon Cognito instead.
  accessKeyId: AWS_KEY_ID,
  // secretAccessKey default can be used while using the downloadable version of DynamoDB. 
  // For security reasons, do not store AWS Credentials in your files. Use Amazon Cognito instead.
  secretAccessKey: AWS_SECRET_KEY
});
var docClient = new AWS.DynamoDB.DocumentClient();

function sendForgotPwEmail(to, pwd, callback) {
  // Create sendEmail params 
  var params = {
    Destination: { /* required */
      ToAddresses: [
        to,
        /* more items */
      ]
    },
    Message: { /* required */
      Body: { /* required */
        // Html: {
        //  Charset: "UTF-8",
        //  Data: "HTML_FORMAT_BODY"
        // },
        Text: {
         Charset: "UTF-8",
         Data: "Your new password is " + pwd
        }
       },
       Subject: {
        Charset: 'UTF-8',
        Data: 'Ask My Phone - Reset Password'
       }
      },
    Source: 'support@askmyphone.net', /* required */
  };

  // Create the promise and SES service object
  var sendPromise = new AWS.SES({apiVersion: '2010-12-01'}).sendEmail(params).promise();

  // Handle promise's fulfilled/rejected states
  sendPromise.then(
    function(data) {
    console.log(data.MessageId);
    callback(true, data.MessageId);
  }).catch(
    function(err) {
    console.error(err, err.stack);
    callback(false, err.stack);
  });
}

class Caches {
  set(key, val, callback) {
    var params = {
          TableName: "caches",
          Item: {
            "key": key,
            "val": val,
          }
        };
    docClient.put(params, function(err, data) {
          if (err) {
            console.log("Unable to add item: " + "\n" + JSON.stringify(err, undefined, 2));
          } else {
            console.log("PutItem succeeded: " + "\n" + JSON.stringify(data, undefined, 2));
          }
          callback(!err, err ? err["message"] : data);
        });
  }

  get(key, callback) {
    docClient.get({
      TableName: 'caches',
      Key: {
          key: key,
        }
    }, function(err, data) {
      if (err) console.log(err);
      else console.log(JSON.stringify(data));
      const succ = err == null && data["Item"] != undefined && (data["Item"]["val"] + "").trim().length > 0;
      callback(succ, succ ? data["Item"] : null);
    });
  }
}

class Api {
  addToken(acc, callback) {
    // if (this.valid()) {
      const token = uuidv4();
      var params = {
        TableName: "users",
        Key: {
          "email": acc,
        },
        UpdateExpression : "SET #token = :token",
        ExpressionAttributeNames: { 
          "#token" : "token" 
        },
        ExpressionAttributeValues:{
          ":token": token
        },
        ReturnValues:"UPDATED_NEW"
      };
      console.log("Api.addToken " + JSON.stringify(params));
      docClient.update(params, function(err, data) {
        if (err) {
          console.log("Unable to add item: " + "\n" + JSON.stringify(err, undefined, 2));
        } else {
          console.log("PutItem succeeded: " + "\n" + JSON.stringify(data, undefined, 2));
        }
        callback(!err, err ? err["message"] : data);
      });
    // }
  }

  forgot(acc, callback) {
      var pw = "amc_"+ Math.random().toString(36).slice(-8);
      var params = {
        TableName: "users",
        Key: {
          "email": acc,
        },
        UpdateExpression : "SET password = :pw",
        ExpressionAttributeValues:{
          ":pw": md5(pw)
        },
        ReturnValues:"UPDATED_NEW"
      };
      console.log("Api.forgot " + JSON.stringify(params));
      docClient.update(params, function(err, data) {
        if (err) {
          console.log("Unable to add item: " + "\n" + JSON.stringify(err, undefined, 2));
        } else {
          console.log("PutItem succeeded: " + "\n" + JSON.stringify(data, undefined, 2));
        }
        if(!err) {
          sendForgotPwEmail(acc, pw, (succ, msg) => {
            callback(succ, succ ? null : msg);
          });
        } else {
          callback(!err, err ? err["message"] : data);
        }
      });
  }

  check(acc, callback) {
    var params = {
      TableName: 'users',
      Key: {
        'email': acc
      }
    };
    console.log("Api.check " + JSON.stringify(params));
    docClient.get(params, function(err, data) {
      if (err) {
        console.log("Unable to read item: " + "\n" + JSON.stringify(err, undefined, 2));
      } else {
        console.log("GetItem succeeded: " + "\n" + JSON.stringify(data, undefined, 2));
      }
      var ret = !err && data.Item != undefined;
      callback(ret, ret ? data.Item : err);
    });
  }

  login(acc, pwd, callback) {
    var params = {
      TableName: 'users',
      FilterExpression: 'email = :email and password = :pwd',
      ExpressionAttributeValues: {
        ':email': acc,
        ':pwd': md5(pwd)
      },
    };
    console.log("Api.login " + JSON.stringify(params));
    docClient.scan(params, function(err, data) {
      if (err) {
        console.log("Unable to read item: " + "\n" + JSON.stringify(err, undefined, 2));
      } else {
        console.log("GetItem succeeded: " + "\n" + JSON.stringify(data, undefined, 2));
      }
      var ret = !err && data.Count > 0;
      callback(ret, ret ? data.Items[0] : err);
    });
  }

  load(callback) {
    if (this.valid()) {
      var acc = localStorage["mycaregiver_email"];
      // var params = {
      //   TableName: 'users',
      //   FilterExpression: 'controller = :controller',
      //   ExpressionAttributeValues: {
      //     ':controller': acc
      //   },
      //   // ProjectionExpression: 'controller',
      // };
      // console.log("Api.load " + JSON.stringify(params));
      // docClient.scan(params, function(err, data) {
      //   if (err) {
      //     console.log("Unable to read item: " + "\n" + JSON.stringify(err, undefined, 2));
      //   } else {
      //     console.log("GetItem succeeded: " + "\n" + JSON.stringify(data, undefined, 2));
      //   }
      //   var ret = !err && data.Count > 0;
      //   callback(ret, ret ? data.Items[0] : err);
      // });
      this.check(acc, callback);
    }
  }

  saveAcc(acc, pwd, controller, fname, lname, callback) {
    if (this.valid()) {
      var params = {
        TableName: "users",
        Key: {
          "email": acc,
        },
        // UpdateExpression : "SET #password = :password, #firstName = :firstName, #lastName = :lastName",
        ExpressionAttributeNames: { 
          // "#password" : "password",
          "#firstName" : "first_name",
          "#lastName" : "last_name" 
        },
        ExpressionAttributeValues:{
          // ":password": pwd,
          ":firstName": fname,
          ":lastName": lname
        },
        ReturnValues:"UPDATED_NEW",
      };
      if(pwd == null || pwd.length == 0) {
        params.UpdateExpression = "SET #firstName = :firstName, #lastName = :lastName";
      } else {
        params.UpdateExpression = "SET #password = :password, #firstName = :firstName, #lastName = :lastName";
        params.ExpressionAttributeNames["#password"] = "password";
        params.ExpressionAttributeValues[":password"] = md5(pwd);
      }
      console.log("Api.saveAcc " + JSON.stringify(params));
      docClient.update(params, function(err, data) {
        if (err) {
          console.log("Unable to add item: " + "\n" + JSON.stringify(err, undefined, 2));
        } else {
          console.log("PutItem succeeded: " + "\n" + JSON.stringify(data, undefined, 2));
        }
        callback(!err, err ? err["message"] : data);
      });
    }
  }

  changePhone(acc, phone, callback) {
    if (this.valid()) {
      var params = {
        TableName: "users",
        Key: {
          "email": acc,
        },
        UpdateExpression : "SET #phone = :phone",
        ExpressionAttributeNames: { 
          "#phone" : "phone",
        },
        ExpressionAttributeValues:{
          ":phone": phone,
        },
        ReturnValues:"UPDATED_NEW",
      };
      console.log("Api.changePhone " + JSON.stringify(params));
      docClient.update(params, function(err, data) {
        if (err) {
          console.log("Unable to add item: " + "\n" + JSON.stringify(err, undefined, 2));
        } else {
          console.log("PutItem succeeded: " + "\n" + JSON.stringify(data, undefined, 2));
        }
        callback(!err, err ? err["message"] : data);
      });
    }
  }

  checkDevice(phone, step, callback) {
    this.set(phone, " ", (succ, data) => {
      fetch("https://6i9xlgdeu4.execute-api.us-east-1.amazonaws.com/default/check_phone_state?p=" + encodeURIComponent(phone) + "&s=" + step)
      .then(() => {
        this.delay(30, () => {
          this.get(phone, callback);
        });
      }, (error) => {
        callback(false, "Please try later.");
      });
    });
  }

  register(acc, pwd, controller, phone, fname, lname, callback) {
    var params = {
      TableName: 'users',
      FilterExpression: 'email = :email',
      ExpressionAttributeValues: {
        ':email': acc,
      },
      ProjectionExpression: 'email',
    };
    console.log("Api.register1 " + JSON.stringify(params));
    docClient.scan(params, function(err, data) {
      if (err) {
        console.log("Unable to read item: " + "\n" + JSON.stringify(err, undefined, 2));
      } else {
        console.log("GetItem succeeded: " + "\n" + JSON.stringify(data, undefined, 2));
      }
      var ret = !err && data.Count > 0;
      if (!ret) {
        var params = {
          TableName: "users",
          Item: {
            "email": acc,
            "password": md5(pwd),
            // "controller": controller,
            "phone": phone,
            "first_name": fname,
            "last_name": lname,
            "pin": "1234",
          }
        };
        console.log("Api.register2 " + JSON.stringify(params));
        docClient.put(params, function(err, data) {
          if (err) {
            console.log("Unable to add item: " + "\n" + JSON.stringify(err, undefined, 2));
          } else {
            console.log("PutItem succeeded: " + "\n" + JSON.stringify(data, undefined, 2));
          }
          callback(!err, err ? err["message"] : data);
        });
      } else {
        callback(false, "Account Exist");
      }
    });
  }

  listCaregiver(callback) {
    if (this.valid()) {
      var acc = localStorage["mycaregiver_email"];
      var params = {
        TableName: 'caregivers',
        FilterExpression: '#user = :user',
        ExpressionAttributeValues: {
          ':user': acc
        },
        ExpressionAttributeNames: { 
          "#user" : "user",
        },
      };
      console.log("Api.listCaregiver " + JSON.stringify(params));
      docClient.scan(params, function(err, data) {
        if (err) {
          console.log("Unable to read item: " + "\n" + JSON.stringify(err, undefined, 2));
        } else {
          console.log("GetItem succeeded: " + "\n" + JSON.stringify(data, undefined, 2));
        }
        var ret = !err;
        callback(ret, ret ? data.Items : err);
        if(ret) {
          localStorage["mycaregiver_list"] = JSON.stringify(data.Items);
        }
      });
    }
  }

  updateCaregiver(id, fname, lname, email, phone, sms, callback) {
    if (this.valid()) {
      var acc = localStorage["mycaregiver_email"];
      var params = {
        TableName: "caregivers",
        Item: {
          "id": id == null ? uuidv4() : id,
          "first_name": fname,
          "last_name": lname,
          "email": email,
          "user": acc,
          "phone": phone,
          "sms": sms
        }
      };
      console.log("Api.updateCaregiver " + JSON.stringify(params));
      docClient.put(params, function(err, data) {
        if (err) {
          console.log("Unable to add item: " + "\n" + JSON.stringify(err, undefined, 2));
        } else {
          console.log("PutItem succeeded: " + "\n" + JSON.stringify(data, undefined, 2));
        }
        callback(!err, err ? err["message"] : "Successful");
      });
    }
  }

  removeCaregiver(id, callback) {
    if (this.valid()) {
      var params = {
          TableName:"caregivers",
          Key:{
              "id": id
          },
      };

      console.log("Api.removeCaregiver " + JSON.stringify(params));
      docClient.delete(params, function(err, data) {
          if (err) {
              console.error("Unable to delete item. Error JSON:", JSON.stringify(err, null, 2));
          } else {
              console.log("DeleteItem succeeded:", JSON.stringify(data, null, 2));
          }
          callback(!err, err ? err["message"] : "Successful");
      });
    }
  }

  mount(email) {
    localStorage["mycaregiver_email"] = email;
  }

  unmount() {
    localStorage.removeItem("mycaregiver_email");
  }

  forced(forced) {
    localStorage["mycaregiver_forced"] = forced;
  }

  valid() {
    return localStorage["mycaregiver_email"] != undefined;
  }

  jump(page) {
    window.location = page;
  }

  cache(idx) {
    return JSON.parse(localStorage["mycaregiver_list"])[idx];
  }

  set(phone, val, callback) {
    new Caches().set(phone, val, callback);
  }

  get(phone, callback) {
    new Caches().get(phone, callback);
  }

  delay(sec, callback) {
    setTimeout(callback, 1000 * sec);
  }
}

export default Api;

// var api = new Api();
// api.addToken("goldmoz@gmail.com", (succ, data) => {
//   console.log(succ + " " + data);
// });



// WEBPACK FOOTER //
// ./src/api.js